import Vue from 'vue';
import VueRouter from 'vue-router';
import Dashboard from '../views/Dashboard.vue';

import KeyValueField from '../components/contentful/key-value/KeyValue.vue';
import EmbedImageField from '../components/contentful/embed-image/EmbedImage.vue';

import axios from 'axios';

Vue.use(VueRouter);

function goLogin () {
  window.location = '/auth/login';
}

const routes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    async beforeEnter (to, from, next) {
      try {
        // check auth status before continuing
        const res = await axios.post('/auth/status');

        if (res.data.authenticated) {
          next();
        }
        else {
          goLogin();
          return false;
        }
      }
      catch (err) {
        console.error(err);
        goLogin();
        return false;
      }
    }
  },
  {
    path: '/contentful/key-value-field',
    name: 'Key-Value Field Type',
    component: KeyValueField
  },
  {
    path: '/contentful/embed-image',
    name: 'Embed Image Field Type',
    component: EmbedImageField
  }
];

const router = new VueRouter({
  routes
});

export default router;
